import { createBrowserHistory } from "history"; // --> no more conflict occurs
export default createBrowserHistory();